<template>
    <div>
        <div>
            <v-dialog v-model="dialogVisible" width="700">
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Create Standard
                    </v-card-title>

                    <v-card-text>
                        <div class="std-padding-side">
                            <v-container class="padding0" grid-list-md>
                                <v-layout wrap>
                                    <v-flex class="xs12">
                                        <v-text-field
                                            v-model="standardName"
                                            v-validate="''"
                                            label="Standard Name"

                                            type="text"
                                            :error-messages="errors.collect('StandardName')"
                                            :data-vv-name="'StandardName'"
                                            required
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container class="padding0" grid-list-md>
                                <v-layout wrap>
                                    <v-flex class="xs12">
                                        <v-autocomplete
                                            v-model="motherRadioSelected"
                                            v-validate="'required'"
                                            :items="fruitTypeOptions"
                                            item-text="name"
                                            item-value="id"
                                            label="Mother Palm"
                                            :return-object="false"

                                            :hide-details="true"
                                            :error-messages="errors.collect('Mother Palm')"
                                            :data-vv-name="'Mother Palm'"
                                            required
                                        />
                                    </v-flex>
                                </v-layout>

                                <div>
                                    <trait-select-form :is-emit-to-parent="isEmitToParent" @emitTraitForms="emitTraitForms2($event, 'mother')" />
                                </div>
                            </v-container>
                            <br>
                            <hr>

                            <v-container class="padding0" grid-list-md>
                                <v-layout wrap>
                                    <v-flex class="xs12">
                                        <v-autocomplete
                                            v-model="fatherRadioSelected"
                                            v-validate="'required'"
                                            :items="fruitTypeOptions"
                                            item-text="name"
                                            item-value="id"
                                            label="Father Palm"
                                            :return-object="false"

                                            :hide-details="true"
                                            :error-messages="errors.collect('Father Palm')"
                                            :data-vv-name="'Father Palm'"
                                            required
                                        />
                                    </v-flex>
                                </v-layout>

                                <div>
                                    <trait-select-form :is-emit-to-parent="isEmitToParent" @emitTraitForms="emitTraitForms1($event, 'father')" />
                                </div>
                            </v-container>
                            <br>
                            <hr>

                            <v-container class="padding0" grid-list-md>
                                <v-layout wrap>
                                    <v-flex class="xs12">
                                        <v-autocomplete
                                            v-model="childRadioSelected"
                                            v-validate="'required'"
                                            :items="fruitTypeOptions"
                                            item-text="name"
                                            item-value="id"
                                            label="Seedling Palm"
                                            :return-object="false"

                                            :hide-details="true"
                                            :error-messages="errors.collect('Seedling Palm')"
                                            :data-vv-name="'Seedling Palm'"
                                            required
                                        />
                                    </v-flex>
                                </v-layout>

                                <div>
                                    <trait-select-form :is-emit-to-parent="isEmitToParent" @emitTraitForms="emitTraitForms3($event, 'child')" />
                                </div>
                            </v-container>
                        </div>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" class="v-btn-bold-color" @click="saveParams()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
export default {
    props: ["tableId","selectId","getUrl","createEditUrl","dialog", "fn", "isReloadParentDropdown"],
    data () {
        return {
            standardName: "",

            fruitTypeOptions: [
                { value: null, name: "No Specify Fruit Type" },
            ],

            field_options: [
                { value: null, text: "Please select an option" },
                { value: "1", text: "ht" },
                { value: "2", text: "wt" },
                { value: "3", text: "ft" },
                { value: "4", text: "bwt" },
                { value: "5", text: "swt" },
            ],
					
            // v-for Father Form
            numberFatherFilters: [ { id: 1, field_selected: "", parameter1: "", parameter2: "" }],
            nextFatherFilterId: 2,
            fatherRadioSelected: null, 
					
            // v-for Mother Form
            numberMotherFilters: [ { id: 1, field_selected: "", parameter1: "", parameter2: "" }],
            nextMotherFilterId: 2,
            motherRadioSelected: null,
					
            // v-for Child Form
            numberChildFilters: [ { id: 1, field_selected: "", parameter1: "", parameter2: "" }],
            nextChildFilterId: 2,
            childRadioSelected: null,

            // Dialog Show or not show
            dialogVisible: false,
            isEmitToParent: false,

            // Emmited Benchamrk Info
            childBenchmarkTraits: [],
            fatherBenchmarkTraits: [],
            motherBenchmarkTraits: [],

            // Check is received trait from dialog
            watcher: 0,
        };
    },
    watch: {
        dialogVisible() {
            this.$emit("update:dialog", this.dialogVisible);
        },
        dialog() {
            this.dialogVisible = this.dialog;
            $("[data-toggle=\"tooltip\"]").tooltip();
        },
        watcher() {
            if ( this.watcher == 3) {
                this.postCreateSeriesWithTrait();
            }
        }
    },
    mounted() {
        this.getFruitType();
    },
    methods: {
        addFatherBenchmark() {
            this.numberFatherFilters.push({
				  id: this.nextFatherFilterId++,
				  field_selected: "",
				  parameter1: "",
				  parameter2: ""
            });
        },
        addMotherBenchmark() {
            this.numberMotherFilters.push({
				  id: this.nextMotherFilterId++,
				  field_selected: "",
				  parameter1: "",
				  parameter2: ""
            });
        },
        addChildBenchmark() {
            this.numberChildFilters.push({
				  id: this.nextChildFilterId++,
				  field_selected: "",
				  parameter1: "",
				  parameter2: ""
            });
        },
        deleteFatherBenchmark(index) {
            if (this.nextFatherFilterId > 2) {
                this.numberFatherFilters.splice(index, 1);
                this.nextFatherFilterId--;
            }
        },
        deleteMotherBenchmark(index) {
            if (this.nextMotherFilterId > 2) {
                this.numberMotherFilters.splice(index, 1);
                this.nextMotherFilterId--;
            }
        },
        deleteChildBenchmark(index) {
            if (this.nextChildFilterId > 2) {
                this.numberChildFilters.splice(index, 1);
                this.nextChildFilterId--;
            }
        },
        postCreateSeriesWithTrait(event) {
            this.isEmitToParent = false;
            var self = this;
            axios({
                method: "POST",
                url: "Standard/CreateWithBenchmarksAndTraits",
                data: {
					  "name": self.standardName,
					  "isPublic": true,
					  "childBenchmark": {
					    "fruitTypeId": self.childRadioSelected,
					    "benchmarkTraits": self.childBenchmarkTraits
					  },
					  "fatherBenchmark": {
					    "fruitTypeId": self.fatherRadioSelected,
					    "benchmarkTraits": self.fatherBenchmarkTraits
					  },
					  "motherBenchmark": {
					    "fruitTypeId": self.motherRadioSelected,
					    "benchmarkTraits": self.motherBenchmarkTraits
					  }
                },
            })
                .then(function (response) {
                    self.dialogVisible = false;
                    self.watcher = 0;
                    self.reloadTable("#" + self.tableId);
                    if (self.fn == "Benchmarking") {
                        self.$emit("update:isReloadParentDropdown", true);
                    }
                });
        },
        emitTraitForms1(event, name) {
            if (event[0].traitId != "") {
                this.fatherBenchmarkTraits = event;
            }
            else {
                this.childBenchmarkTraits = null;
            }
            this.watcher++;
        },
        emitTraitForms2(event, name) {
            if (event[0].traitId != "") {
                this.motherBenchmarkTraits = event;
            }
            else {
                this.childBenchmarkTraits = null;
            }
            this.watcher++;
        },
        emitTraitForms3(event, name) {
            if (event[0].traitId != "") {
                this.childBenchmarkTraits = event;
            }
            else {
                this.childBenchmarkTraits = null;
            }
            this.watcher++;
        },
        saveParams() {
            this.dialogVisible = false;
            this.isEmitToParent = true;
        },
        getFruitType() {
            var self = this;
            axios({
                method: "GET",
                url: "FruitType/GetAllForDropdown",
            })
                .then(function (response) {
                    response.data.result.forEach(function(element) {
                        self.fruitTypeOptions.push(element);
                    });
                });
        },
        resetForm() {
            this.fruitTypeOptions = [];
        }
    }
};
</script>

<style scoped>
	.formInlineText{
		margin: 0 1rem;
	}
	.labelLine{
		margin: 8px 0;
	}
/*	.plusBtn{
		color: #007bff;
	}*/
	.radioOptions{
		display: inline-block;
		margin: 0 5px;
	}
	.radioOptions .custom-control .custom-control-label{
		font-weight: 500;
	}
	.width30{
		width: 30%;
	}
</style>


// WEBPACK FOOTER //
// src/smallComponents/StardardDialog.vue